import { Component, OnInit, ViewChild } from '@angular/core';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CrudService } from 'src/app/services/crud/crud.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { AplicacionModel } from 'src/app/services/sso/models/aplicacion.model';
import { EmpresaModel } from 'src/app/services/sso/models/empresa.model';
import { ModuloAppEmpModel, ModuloModel } from 'src/app/services/sso/models/modulo.model';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { environment } from 'src/environments/environment';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-app-modulo-emp',
  templateUrl: './app-modulo-emp.component.html',
  styleUrls: ['./app-modulo-emp.component.css']
})
export class AppModuloEmpComponent implements OnInit {

  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('formAdd') formAdd: jqxWindowComponent;

  public langGrid = JqWidgets.getLocalization('es');
  mostrarEdit: boolean = false;
  dataAdapter: any;
  private componentRef = null;
  public theme = environment.tema;
  modulosAdapter: any;

  public appsArray: AplicacionModel[] = [];
  public empArray: EmpresaModel[] = [];
  public modulosArray: ModuloModel[] = [];
  public apps = new Map<number, AplicacionModel>();
  public empresas = new Map<number, EmpresaModel>();
  public modulos = new Map<number, ModuloModel>();
  public rows: any[] = [];

  moduloAppEmpSelec: ModuloAppEmpModel;
  appSelec: AplicacionModel;
  empSelec: EmpresaModel;
  moduloSelec: ModuloModel;

  dataSource: any;
  dataSourceApp: any;
  dataAdapterApp: any;
  dataSourceEmp: any;
  dataAdapterEmp: any;
  dataSourceModulo: any;
  dataAdapterModulo: any;

  constructor(private menuService: MenuService,
    private crudService: CrudService,
    private modal: NzModalService) { }
  ngOnInit(): void { }
  /**Inicializa el componente
  */
  async ngAfterViewInit() {
    this.loader.open();
    this.appsArray = await this.crudService.getApps();
    this.empArray = await this.crudService.getEmpresas();
    this.modulosArray = await this.menuService.getModulos();

    const emp: EmpresaModel = new EmpresaModel()
    emp.Id = 0;
    emp.IdGestion = 0;
    emp.Nombre = "";
    this.empArray.push(emp);

    if (this.appsArray) {
      this.appsArray.forEach(app => {
        this.apps.set(app.Id, app);
      });
    }
    if (this.empArray) {
      this.empArray.forEach(emp => {
        this.empresas.set(emp.Id, emp);
      });
    }
    if (this.modulosArray) {
      this.modulosArray.forEach(modulo => {
        this.modulos.set(modulo.Id, modulo);
      });
    }
    this.fillGrid();
    this.loader.close();
  }

  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  // Preparo las columnas del grid
  public columns = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'AppId', columntype: 'textbox', datafield: 'appId', width: 10, hidden: true
    },
    {
      text: ' Aplicación', columntype: 'textbox', filtertype: 'textbox', datafield: 'appNombre', width: 320,
      editable: false,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    {
      text: 'EmpresaId', columntype: 'textbox', datafield: 'empId', width: 10, hidden: true
    },
    {
      text: 'Empresa', columntype: 'textbox', filtertype: 'textbox', datafield: 'empNombre', width: '320', editable: false
    },
    {
      text: 'ModuloId', columntype: 'textbox', datafield: 'moduloId', width: 10, hidden: true
    },
    {
      text: 'Módulo', datafield: 'moduloNombre', displayfield: 'ModuloNombre', columntype: 'dropdownlist', width: 'auto',
      createeditor: (row: number, value: any, editor: any): void => {
        editor.jqxDropDownList({
          width: '250px', height: 32, source: this.modulosAdapter,
          displayMember: 'label', valueMember: 'value'
        });
      }
    },
  ];

  // Preparo las columnas del grid de aplicaciones
  public columnsApp = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Aplicación', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 290,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  // Preparo las columnas del grid de empresas
  public columnsEmp = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Empresa', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 280,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  // Preparo las columnas del grid de menús
  public columnsMenu = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Modulo', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 280,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  async fillGrid() {
    this.loader.open();
    //const menusApp = await this.menuService.getMenusAppEmp();
    const moduloApp = await this.menuService.getModulosByApp();

    if (moduloApp) {
      this.rows = [];
      moduloApp.forEach(appEmp => {
        let id, moduloId, appId, moduloNombre, appNombre, empId, empNombre;
        id = appEmp.Id;
        moduloId = appEmp.ModuloId;
        moduloNombre = this.modulos.get(moduloId).Nombre;
        appId = appEmp.AplicacionId;
        appNombre = this.apps.get(appId).Nombre;
        empId = appEmp.EmpresaId;
        empNombre = this.empresas.get(empId).Nombre;
        this.rows.push({
          Id: id,
          AplicacionId: appId,
          AppNombre: appNombre,
          ModuloId: moduloId,
          ModuloNombre: moduloNombre,
          EmpresaId: empId,
          EmpNombre: empNombre
        });
      });
    }

    // Creo un adaptador con los datos de todos los menús para poner en el combo
    const modulosSource =
    {
      datatype: 'array',
      datafields: [
        { name: 'label', type: 'string', map: 'Nombre' },
        { name: 'value', type: 'number', map: 'Id' }
      ],
      localdata: this.modulosArray
    };
    this.modulosAdapter = new jqx.dataAdapter(modulosSource, { autoBind: true });
    if (this.rows) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'appId', type: 'number', map: 'AppId' },
          { name: 'appNombre', type: 'string', map: 'AppNombre' },
          { name: 'empId', type: 'number', map: 'EmpresaId' },
          { name: 'empNombre', type: 'string', map: 'EmpNombre' },
          { name: 'moduloId', type: 'number', map: 'ModuloId' },
          {
            name: 'ModuloNombre', value: 'ModuloNombre',
            values: {
              source: this.modulosAdapter.records, value: 'value', name: 'label'
            }
          },
          { name: 'moduloNombre', type: 'string' },
        ],
        localdata: this.rows,
        sortcolumn: 'appNombre',
        sortdirection: 'asc'
      }
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
    }
    this.loader.close();
  }

  onBorrar() {
    if (!this.moduloAppEmpSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione un registro de la lista', 2000);
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere quitar el módelo: ' + this.modulos.get(this.moduloAppEmpSelec.ModuloId).Nombre + ' de la empresa:' +
        this.empresas.get(this.moduloAppEmpSelec.EmpresaId).Nombre + ' ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess('ATENCION', 'Registro borrado', 2000);
        await this.menuService.deleteModuloAppEmpresa(this.moduloAppEmpSelec);
        for (let i = 0; i < this.rows.length; i++) {
          if (this.moduloAppEmpSelec.Id === this.rows[i].Id) {
            this.rows.splice(i, 1);
            break;
          }
        }
        this.moduloAppEmpSelec = null;
        this.grid.updatebounddata('cells');
      }
    });
  }

  onCrear() {
    this.mostrarEdit = true;
    this.appSelec = null;
    this.empSelec = null;
    this.moduloSelec = null;
    const t = setTimeout(() => {
      clearTimeout(t);
      // Relleno el grid de aplicaciones
      this.dataSourceApp = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.appsArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterApp = new jqx.dataAdapter(this.dataSourceApp);
      // Relleno el grid de empresas
      this.dataSourceEmp = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.empArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterEmp = new jqx.dataAdapter(this.dataSourceEmp);
      // Relleno el grid de menús
      this.dataSourceModulo = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.modulosArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterModulo = new jqx.dataAdapter(this.dataSourceModulo);
    }, 1000);
  }
  onRowSelect(event: any) {
    this.moduloAppEmpSelec = this.rows[event.args.rowindex];
  }
  onCellEndEdit(event: any) {
    const id = event.args.row.id;
    const appId = event.args.row.appId;
    const moduloId = event.args.value.value;
    const empId = event.args.row.empId;
    const menu = {
      Id: id,
      MenuId: moduloId,
      AplicacionId: appId,
      EmpresaId: empId
    }
    this.menuService.saveMenuAplicacionEmpresa(menu);
    MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
    event.args.row.observ = this.modulos.get(moduloId).Observaciones;
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
  onCloseAdd() {
    this.mostrarEdit = false;
  }
  onRowSelectApp(event: any) {
    this.appSelec = this.appsArray[event.args.rowindex];
  }

  onRowSelectEmp(event: any) {
    this.empSelec = this.empArray[event.args.rowindex];
  }

  onRowSelectModulo(event: any) {
    this.moduloSelec = this.modulosArray[event.args.rowindex];
  }

  onGuardar() {
    if (!this.appSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione la aplicación', 2000);
      return;
    }
    // if (!this.empSelec) {
    //   MainComponent.showError('ATENCIÓN', 'Seleccione la empresa', 2000);
    //   return;
    // }
    if (!this.moduloSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione el menú', 2000);
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere guardar la información ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess('ATENCION', 'Registro almacenado', 2000);
        const reg: ModuloAppEmpModel = new ModuloAppEmpModel();
        reg.Id = 0;
        reg.AplicacionId = this.appSelec.Id;
        reg.EmpresaId = this.empSelec.Id;
        reg.ModuloId = this.moduloSelec.Id;
        await this.menuService.saveModulosAplicacionEmpresa(reg);
        this.fillGrid();
        this.formAdd.close();
      }
    });
  }
}
